import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Container,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Typography,
  Divider,
  CircularProgress,
  Grid,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  AddBeneficiary,
  getBeneficiaryRelations,
  getBeneficiaryInfo,
  GstUserPanDataFetch,
  getNomineeInfo,
} from './APIs/action';
import NomineeAccordion from './Component/Nominee_accordian';
import AddBasicDetails from './Component/AddBasicDetails';
import { UserFileDict } from '../../../utils/settings';
import { fileReaderPromise } from '../../../utils/utilFuntions';

export const PANRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
export const phoneNumberRegex = /^([+]\d{2})?\d{10}$/;
export const getAge = (inputDate) => {
  if (!inputDate) return null;
  const today = new Date();
  const birthDate = new Date(inputDate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
export const calculateAgesAndFlags = (dates) => {
  if (!dates || dates.length === 0) return [];
  return dates.map((date) => {
    const age = getAge(date);
    const ageFlag = age > 60 || age < 18;
    return { age, ageFlag };
  });
};

const AddNewBeneficiary = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    beneficiary: {},
    nominee_details: [],
  });
  const [beneficiaryRelationList, setBeneficiaryRelationList] = useState([]);
  const [nomineeRelationList, setNomineeRelationList] = useState([]);
  const [inValidPan, setInValidPan] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const [beneficiaryAge, setBeneficiaryAge] = useState(null);
  const [beneficiaryAgeFlag, setBeneficiaryAgeFlag] = useState(false);
  const [nomineeAges, setNomineeAges] = useState([]);
  const [isNomineeAdded, setIsNomineeAdded] = useState(false);
  const [beneficiaryList, setBeneficiaryList] = useState([]);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState('');
  const [selectedNominee, setSelectedNominee] = useState('');

  const [loader, setLoader] = useState(false);

  const location = useLocation();
  const insuranceType = location.state || {};

  useEffect(() => {
    if (!insuranceType.data) {
      navigate('/my-benefits/benefits-available', { replace: true });
    }
  }, [insuranceType]);

  const [nominee, setNominee] = useState({
    id: null,
    first_name: '',
    last_name: '',
    phone_no: '',
    email: '',
    relation: '',
    pancard_no: '',
    date_of_birth: '',
    benefit_type: insuranceType.data || '',
    allocation_percent: 100,
    nominee_uploadedFile: '',
    document_upload_details: {
      file_str_base64: '',
      file_name: '',
      file_type: '',
    },
  });
  const [beneficiary, setBeneficiary] = useState({
    first_name: '',
    last_name: '',
    phone_no: '',
    email: '',
    relation: '',
    pancard_no: '',
    date_of_birth: '',
    beneficiary_benefits: insuranceType.data || '',
    beneficiary_uploadedFile: '',
    document_upload_details: {
      file_str_base64: '',
      file_name: '',
      file_type: '',
    },
    nominee_details: [],
  });
  const [uploadedFileName, setUploadedFileName] = useState('');
  const addNominee = () => {
    if (beneficiary.nominee_details.length >= 2) {
      toast.error('You can only add up to 2 nominees');
      return;
    }
    setBeneficiary((prevBeneficiary) => ({
      ...prevBeneficiary,
      nominee_details: [...prevBeneficiary.nominee_details, nominee],
    }));
    setIsNomineeAdded(true);
  };
  const removeNominee = (index) => {
    setBeneficiary((prevBeneficiary) => {
      const updatedNomineeDetails = prevBeneficiary.nominee_details.filter(
        (_, i) => i !== index,
      );
      if (updatedNomineeDetails.length === 1) {
        updatedNomineeDetails[0].allocation_percent = 100;
      }

      if (updatedNomineeDetails.length < 1) {
        setIsNomineeAdded(false);
      }
      return {
        ...prevBeneficiary,
        nominee_details: updatedNomineeDetails,
      };
    });
  };

  const getRelation = async () => {
    const { data, error, message } = await getBeneficiaryRelations();
    if (!error) {
      if (insuranceType) {
        const BeneficiaryFilteredData =
          insuranceType.data === 'Staff Insurance'
            ? data.filter((relation) => relation === 'Employee')
            : data.filter((relation) => relation !== 'Employee');

        setBeneficiaryRelationList(BeneficiaryFilteredData);
        const NomineeFilteredData = data.filter(
          (relation) => relation !== 'Employee' && relation !== 'Self',
        );
        setNomineeRelationList(NomineeFilteredData);
      } else {
        setBeneficiaryRelationList(data);
        setNomineeRelationList(data.filter((relation) => relation !== 'Self'));
      }
    } else {
      toast.error(message);
    }
  };
  useEffect(() => {
    if (beneficiary.date_of_birth) {
      const { age, ageFlag } = calculateAgesAndFlags([
        beneficiary.date_of_birth,
      ])[0];
      setBeneficiaryAge(age);
      setBeneficiaryAgeFlag(ageFlag);
    }
    if (beneficiary.nominee_details.length > 0) {
      const results = calculateAgesAndFlags(
        beneficiary.nominee_details.map((nominee) => nominee.date_of_birth),
      );
      setNomineeAges(results.map((result) => result.age));
    }
  }, [beneficiary.date_of_birth, beneficiary.nominee_details]);

  useEffect(() => {
    getRelation();
  }, []);

  const getBeneficiaries = async () => {
    setLoader(true);
    const { error, message, data } = await getBeneficiaryInfo();
    setLoader(false);
    if (!error) {
      if (data) {
        setBeneficiaryList(data);
      } else setBeneficiaryList([]);
    } else {
      return toast.error(message);
    }
  };
  useEffect(() => {
    getBeneficiaries();
  }, []);

  useEffect(() => {
    if (selectedBeneficiary) {
      getNomineeInfo(selectedBeneficiary, insuranceType.data)
        .then((response) => {
          if (response && response.data.length > 0) {
            const nomineeData = response.data;
            setBeneficiary((prevBeneficiary) => ({
              ...prevBeneficiary,
              nominee_details: nomineeData.map((nominee, i) => ({
                  ...nominee,
                  id: nominee?.id || null,
                  first_name: nominee?.first_name || '',
                  last_name: nominee?.last_name || '',
                  date_of_birth: nominee?.date_of_birth || '',
                  email: nominee?.email || '',
                  phone_no: nominee?.phone_no || '',
                  pancard_no: nominee?.pancard_no || '',
                  relation: nominee?.relation || '',
                  benefit_type: insuranceType.data,
                  allocation_percent: 50,
                  nominee_uploadedFile: '',
                  document_upload_details: {
                    file_str_base64: '',
                    file_name: '',
                    file_type: '',
                  },
                }),
                
              ),
            }));
            setIsNomineeAdded(true);
          } else {
            removeNominee(0);
            removeNominee(1);
            setIsNomineeAdded(false);
          }
        })
        .catch((error) => console.error('Error fetching nominee info:', error));
    }
  }, [selectedBeneficiary, insuranceType]);
  
  const handleSelectChange = async(event, type, index = null) => {
    const selectedId = event.target.value;
    if (type === 'beneficiary') {
      setSelectedBeneficiary(selectedId);
      const selectedData = beneficiaryList.find(
        (beneficiary) => beneficiary.id === selectedId,
      );
      if (selectedData) {
        setBeneficiary((prevBeneficiary) => ({
          ...prevBeneficiary,
          first_name: selectedData.first_name || '',
          last_name: selectedData.last_name || '',
          date_of_birth: selectedData.date_of_birth || '',
          email: selectedData.email || '',
          phone_no: selectedData.phone_no || '',
          pancard_no: selectedData.pancard_no || '',
          relation: selectedData.relation || '',
        }));
      }
      
    } else if (type === 'nominee') {
      setSelectedNominee(selectedId);
      const filteredNomineeList = beneficiaryList.filter(
        (nominee) => nominee.id !== selectedBeneficiary,
      );
      const selectedData = filteredNomineeList.find(
        (nominee) => nominee.id === selectedId,
      );
      if (selectedData && index !== null) {
        setBeneficiary((prevBeneficiary) => ({
          ...prevBeneficiary,
          nominee_details: prevBeneficiary.nominee_details.map((nominee, i) =>
            i === index
              ? {
                  ...nominee,
                  id: selectedData.id || null,
                  first_name: selectedData.first_name || '',
                  last_name: selectedData.last_name || '',
                  date_of_birth: selectedData.date_of_birth || '',
                  email: selectedData.email || '',
                  phone_no: selectedData.phone_no || '',
                  pancard_no: selectedData.pancard_no || '',
                }
              : nominee,
          ),
        }));
      }
    }
  };
  const OnAddBeneficiary = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!beneficiary.first_name)
      newErrors.first_name = 'Please enter Beneficiary first name';

    if (!beneficiary.last_name)
      newErrors.last_name = 'Please enter Beneficiary last name';

    if (beneficiary.phone_no.length < 10)
      newErrors.phone_no = 'Enter a 10-digit mobile number';

    if (!phoneNumberRegex.test(beneficiary.phone_no))
      newErrors.phone_no = 'Enter a valid mobile number';

    if (!beneficiary.email) newErrors.email = 'Enter a valid email id';

    if (!beneficiary.pancard_no) newErrors.pancard_no = 'Enter a PAN number';

    if (!beneficiary.pancard_no)
      newErrors.pancard_no = 'Enter a 10-digit Pan Number';

    if (!beneficiary.relation) newErrors.relation = 'Please Select relation';

    if (!beneficiary.date_of_birth)
      newErrors.date_of_birth = 'Please Enter valid Date';

    const nomineeErrors = [];
    if (
      beneficiary.nominee_details &&
      Array.isArray(beneficiary.nominee_details)
    ) {
      beneficiary.nominee_details.forEach((nominee, index) => {
        const nomineeError = {};
        if (!nominee) return;
        if (!nominee.first_name)
          nomineeError.first_name = 'Please enter Nominee first name';
        if (!nominee.last_name)
          nomineeError.last_name = 'Please enter Nominee last name';
        if (nominee.phone_no.length < 10)
          nomineeError.phone_no = 'Enter a 10-digit mobile number';
        if (!phoneNumberRegex.test(nominee.phone_no))
          nomineeError.phone_no = 'Enter a valid mobile number';
        if (!nominee.email) nomineeError.email = 'Enter a valid email id';
        if (!nominee.pancard_no) {
          nomineeError.pancard_no = 'Enter a valid PAN number';
        }
        if (!nominee.pancard_no)
          nomineeError.pancard_no = 'Enter a 10-digit Pan Number';

        if (!nominee.relation) nomineeError.relation = 'Please Select relation';

        if (!nominee.date_of_birth)
          nomineeError.date_of_birth = 'Please Enter valid Date';

        if (Object.keys(nomineeError).length > 0) {
          nomineeErrors[index] = nomineeError;
        }
      });
    }
    setErrors({
      ...newErrors,
      nominee_details: nomineeErrors,
    });
    if (Object.keys(newErrors).length > 0 || nomineeErrors.length > 0) {
      return;
    }

    const nomineeDetails =
      beneficiary?.nominee_details && beneficiary.nominee_details.length > 0
        ? beneficiary.nominee_details
        : null;

    const isDocumentEmpty =
      beneficiary?.document_upload_details?.file_str_base64 === '' &&
      beneficiary?.document_upload_details?.file_name === '' &&
      beneficiary?.document_upload_details?.file_type === '';

    const payload = {
      id: selectedBeneficiary ? selectedBeneficiary : null,
      first_name: beneficiary?.first_name,
      last_name: beneficiary?.last_name,
      phone_no: beneficiary?.phone_no,
      pancard_no: beneficiary?.pancard_no,
      email: beneficiary?.email,
      date_of_birth: beneficiary?.date_of_birth,
      relation: beneficiary?.relation,
      benefit_type: beneficiary?.beneficiary_benefits,
      document_upload_details: isDocumentEmpty
        ? null
        : beneficiary?.document_upload_details,
      nominee_details: nomineeDetails,
    };
    setLoader(true);
    const { error, message } = await AddBeneficiary(payload);
    setLoader(false);
    if (!error) {
      navigate('/my-benefits/benefits-summary');
      toast.success('Beneficiary added Successfully');
    } else {
      toast.error(message);
    }
  };
  const onPanBlur = async (
    e,
    setStateFunc,
    isNominee = false,
    index = null,
  ) => {
    const value = e.target.value;
    if (value) {
      const { error, message, data } = await GstUserPanDataFetch(value, false);
      if (!error) {
        setInValidPan(false);
        if (isNominee && index !== null) {
          setStateFunc((prevBeneficiary) => ({
            ...prevBeneficiary,
            nominee_details: prevBeneficiary.nominee_details.map((nominee, i) =>
              i === index
                ? {
                    ...nominee,
                    id: null,
                    first_name: data?.first_name || data?.name || '',
                    last_name: data?.last_name || '',
                    date_of_birth: data?.date_of_birth || '',
                    email: data?.email || '',
                    phone_no: data?.phone || '',
                  }
                : nominee,
            ),
          }));
          setSelectedNominee(null);
        } else {
          setStateFunc((prevBeneficiary) => ({
            ...prevBeneficiary,
            first_name: data?.first_name || data?.name || '',
            last_name: data?.last_name || '',
            date_of_birth: data?.date_of_birth || '',
            email: data?.email || '',
            phone_no: data?.phone || '',
          }));
          setSelectedBeneficiary(null);
        }
      } else {
        toast.error(message);
        setInValidPan(true);
      }
    }
  };
  const handleUpload = async (
    e,
    setStateFunc,
    isNominee = false,
    index = null,
  ) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const base64String = await fileReaderPromise(file);
        const fileDetails = {
          file_str_base64: base64String
            .replace('data:', '')
            .replace(/^.+,/, ''),
          file_name: file.name,
          file_type: UserFileDict['PAN_CARD'],
        };
        setUploadedFileName(file.name);

        if (isNominee && index !== null) {
          setStateFunc((prevBeneficiary) => ({
            ...prevBeneficiary,
            nominee_details: prevBeneficiary.nominee_details.map((nominee, i) =>
              i === index
                ? {
                    ...nominee,
                    document_upload_details: fileDetails,
                  }
                : nominee,
            ),
          }));
        } else {
          // Update beneficiary document upload details
          setStateFunc((prevBeneficiary) => ({
            ...prevBeneficiary,
            document_upload_details: fileDetails,
          }));
          setErrors((prevErrors) => ({
            ...prevErrors,
            document_upload_details: '', // Clear any previous error
          }));
        }
        toast.success('File uploaded successfully!');
      } catch (error) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          document_upload_details: 'Error reading file',
        }));
      }
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        document_upload_details: 'Please upload a valid file',
      }));
      toast.error('Please upload a valid file');
    }
  };
  const handleNomineeInputChange = (index, updatedNominee) => {
    const isNomineeDocumentEmpty =
      updatedNominee.document_upload_details?.file_str_base64 === '' &&
      updatedNominee.document_upload_details?.file_name === '' &&
      updatedNominee.document_upload_details?.file_type === '';

    const updatedNomineeWithDocumentCheck = {
      ...updatedNominee,
      document_upload_details: isNomineeDocumentEmpty
        ? null
        : updatedNominee.document_upload_details,
    };

    setBeneficiary((prevBeneficiary) => ({
      ...prevBeneficiary,
      nominee_details: prevBeneficiary.nominee_details.map((nominee, i) =>
        i === index
          ? { ...nominee, ...updatedNomineeWithDocumentCheck }
          : nominee,
      ),
    }));
  };
  const handleAllocationChange = (index, e) => {
    const allocationPercent = e.target.value;
    setBeneficiary((prev) => {
      const updatedNomineeDetails = [...prev.nominee_details];
      updatedNomineeDetails[index] = {
        ...updatedNomineeDetails[index],
        allocation_percent: allocationPercent,
      };
      if (allocationPercent === 50) {
        if (updatedNomineeDetails.length === 1) {
          updatedNomineeDetails.push({
            id: null,
            first_name: '',
            last_name: '',
            phone_no: '',
            email: '',
            relation: '',
            pancard_no: '',
            date_of_birth: '',
            benefit_type: nominee.benefit_type,
            allocation_percent: 50,
            nominee_uploadedFile: '',
            document_upload_details: {
              file_str_base64: '',
              file_name: '',
              file_type: '',
            },
          });
        }
      } else {
        if (updatedNomineeDetails.length > 1) {
          updatedNomineeDetails.splice(1, 1);
        }
      }

      return {
        ...prev,
        nominee_details: updatedNomineeDetails,
      };
    });
  };
  const filteredBeneficiaries = Array.isArray(beneficiaryList)
    ? beneficiaryList.filter((beneficiary) => {
        if (insuranceType.data === 'Staff Insurance') {
          return beneficiary.relation === 'Employee';
        } else {
          return beneficiary.relation !== 'Employee';
        }
      })
    : [];
  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '5rem',
          height: window.innerHeight,
          overflowY: 'auto',
        }}
      >
        <Stack
          spacing={2}
          direction='row'
        >
          <IconButton
            aria-label='Screenback'
            sx={{ color: 'black' }}
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon sx={{ fontSize: { xs:'18px', sm: '30px' } }} />
          </IconButton>
          <Typography sx={{ fontSize: { xs:'18px', sm: '30px' }}}>
            Add New Beneficiary for {insuranceType.data || ''}
          </Typography>
        </Stack>
        <Divider sx={{ mt: '1rem', mb: '3rem' }} />
        <Card
          sx={{
            px: { sm:'3rem', xs:'1.5rem' },
            py: '3rem',
            height: 'auto',
          }}
        > 
          <Grid container spacing={2}>
            <Grid item xs={12} >
              {beneficiaryList && beneficiaryList.length > 0 && (
                <FormControl
                  fullWidth
                  sx={{ mb: '1rem', width: '99%' }}
                >
                  <InputLabel id='beneficiary-select-label'>
                    Existing Users
                  </InputLabel>
                  <Select
                    labelId='beneficiary-select-label'
                    id='beneficiary-select'
                    value={selectedBeneficiary}
                    label='Select Beneficiary'
                    onChange={(event) => handleSelectChange(event, 'beneficiary')}
                  >
                    {filteredBeneficiaries.length > 0 ? (
                      filteredBeneficiaries.map((beneficiary, index) => (
                        <MenuItem
                          key={index}
                          value={beneficiary.id}
                        >
                          {beneficiary.first_name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>
                        Data not available for Staff Insurance
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              )}
              <form onSubmit={OnAddBeneficiary}>
                <AddBasicDetails
                  stateType={beneficiary}
                  setStateType={setBeneficiary}
                  errors={errors}
                  handleUpload={(e) => handleUpload(e, setBeneficiary)}
                  onPanBlur={onPanBlur}
                  relationList={beneficiaryRelationList}
                  age={beneficiaryAge}
                  today={today}
                  uploadedFileName={uploadedFileName}
                />
                {beneficiary.nominee_details.length > 0 &&
                  beneficiary.nominee_details.map((nominee, index) => (
                    <React.Fragment key={index}>
                      <NomineeAccordion
                        index={index}
                        nominee={nominee}
                        setNominee={(updatedNominee) =>
                          handleNomineeInputChange(index, updatedNominee)
                        }
                        errors={errors.nominee_details[index] || {}}
                        handleUpload={(e) =>
                          handleUpload(e, setBeneficiary, true, index)
                        }
                        onPanBlur={(e) =>
                          onPanBlur(e, setBeneficiary, true, index)
                        }
                        relationList={nomineeRelationList}
                        today={today}
                        age={nomineeAges[index]}
                        addNominee={addNominee}
                        removeNominee={removeNominee}
                        handleAllocationChange={handleAllocationChange}
                        beneficiary={beneficiary}
                        beneficiaryList={beneficiaryList}
                        selectedBeneficiary={selectedBeneficiary}
                        selectedNominee={selectedNominee}
                        handleSelectChange={(event) =>
                          handleSelectChange(event, 'nominee', index)
                        }
                        insuranceType={insuranceType.data}
                      />
                    </React.Fragment>
                  ))}
                {!isNomineeAdded &&
                  insuranceType.data !== 'Medical Insurance' && (
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={addNominee}
                      sx={{ my: 2 }}
                    >
                      Add Nominee
                    </Button>
                  )}
                <Box sx={{ mt: 2, width: '100%' }}>
                  <Button
                    disabled={loader || beneficiaryAgeFlag || inValidPan}
                    type='submit'
                    variant='outlined'
                    color='primary'
                    fullWidth
                    startIcon={
                      loader && (
                        <CircularProgress
                          sx={{ color: 'white' }}
                          size={20}
                        />
                      )
                    }
                  >
                    {loader ? 'Loading...' : 'Add beneficiary '}
                  </Button>
                </Box>
              </form>
            </Grid>
          </Grid>
        </Card>
        
      </Container>
    </>
  );
};
export default AddNewBeneficiary;
